import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["items", "arrow"]

  toggle() {
    this.itemsTarget.classList.toggle("hidden")
    this.arrowTarget.classList.toggle("rotate-180")
  }
}
